import { render, staticRenderFns } from "./ComplianceCard.vue?vue&type=template&id=11446372&scoped=true&"
import script from "./ComplianceCard.vue?vue&type=script&lang=js&"
export * from "./ComplianceCard.vue?vue&type=script&lang=js&"
import style0 from "./ComplianceCard.vue?vue&type=style&index=0&id=11446372&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11446372",
  null
  
)

export default component.exports